import { Checkbox } from "@mui/material";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { RegisterMessages } from "@/messages/register/register.messages";

type Props = {
  messages: RegisterMessages;
  isCheckboxChecked: boolean;
  setIsCheckboxChecked: (checked: boolean) => void;
  termsUrl: string;
  privacyUrl: string;
};

function UserConsentSection({
  messages,
  isCheckboxChecked,
  setIsCheckboxChecked,
  termsUrl,
  privacyUrl,
}: Props) {
  return (
    <MDBox display="flex" alignItems="center">
      <Checkbox
        checked={isCheckboxChecked}
        onChange={(event, checked) => setIsCheckboxChecked(checked)}
        color="primary"
        sx={{ 
          paddingLeft: 0,
          "& .MuiTouchRipple-root": {
            display: "none",
          },
        }}
      />

      <MDTypography variant="button" fontWeight="regular" color="dark">
        {messages.agreeTo}&nbsp;
        <MDTypography
          component="a"
          {...{ href: termsUrl, target: "_blank", rel: "noopener noreferrer" }}
          variant="button"
          fontWeight="bold"
          color="dark"
          sx={{ cursor: "pointer", userSelect: "none", textDecoration: "underline" }}
        >
          {messages.termsOfService}
        </MDTypography>
        <MDTypography variant="button" fontWeight="regular" color="dark">
          &nbsp;{messages.andText}&nbsp;
        </MDTypography>
        <MDTypography
          component="a"
          {...{ href: privacyUrl, target: "_blank", rel: "noopener noreferrer" }}
          variant="button"
          fontWeight="bold"
          color="dark"
          sx={{ cursor: "pointer", userSelect: "none", textDecoration: "underline" }}
        >
          {messages.privacyPolicy}
        </MDTypography>
      </MDTypography>
    </MDBox>
  );
}

export default UserConsentSection;
